export class Durable
{
  private start_time: number;
  private duration: number;
  private finish_clip_time: number;

  constructor(
    start_time: number,
    duration: number,
  )
  {
    this.start_time       = start_time;
    this.duration         = duration;
    this.finish_clip_time = start_time + duration;
  }

  public calcProgress( now:number ):number
  {
    if ( this.duration <= 0 )
      return 1;

    const elapsed = now - this.start_time;
    return elapsed / this.duration;
  }

  public startTime():number
  {
    return this.start_time;
  }

  // private finishTime():number
  // {
  //   return min2( this.finish_clip_time, this.start_time + this.duration );
  // }

  public getDuration():number
  {
    return this.duration;
  }

  public isStarted( now:number ): boolean
  {
    return now >= this.start_time;
  }

  public isFinished( now:number ): boolean
  {
    return now >= this.finish_clip_time;//this.start_time + this.duration;
  }

  protected setFinished( now:number ):void
  {
    if ( this.finish_clip_time > now )
      this.finish_clip_time = now;
  }

  public isInsideIn( dr:Durable ): boolean
  {
    return this.start_time >= dr.start_time
      && this.finish_clip_time <= dr.finish_clip_time;
  }

  public isBefore_andIntersects( dr:Durable ): boolean
  {
    return this.start_time < dr.start_time
      && this.finish_clip_time > dr.start_time;
  }

  public isAfter_andIntersects( dr:Durable ): boolean
  {
    return this.finish_clip_time > dr.finish_clip_time
      && this.start_time < dr.finish_clip_time;
  }

  public cutOffTheBeginningBy( dr:Durable ): void
  {
    this.start_time = dr.finish_clip_time;
  }

  public cutOffTheEndingBy( dr:Durable ): void
  {
    this.finish_clip_time = dr.start_time;
  }

  public setDuration( duration:number ): void
  {
    if ( this.finish_clip_time < this.start_time + this.duration )
    {
      console.warn( `setDuration()   finish_clip_time ${this.finish_clip_time} < start_time ${this.start_time} + duration ${this.duration}` );
      return;
    }

    this.duration = duration;
    this.finish_clip_time = this.start_time + duration;
  }
/*
  public clipDurationBy( dr:Durable ): void
  {
    if ( this.start_time >= dr.finish_clip_time
      || this.finish_clip_time <= dr.start_time ) // no need to clip
      return;
    
    if ( this.start_time < dr.start_time )
    {
      this.duration = dr.start_time - this.start_time;
      return;
    }

    if ( this.finish_clip_time > dr.finish_clip_time )
    {
      this.start_time = dr.finish_clip_time;
      return;
    }

    console.error( `Durable.clipDurationBy()   this ${this.toStrDurable()}   dr ${dr.toStrDurable()}` );
  }
*/
  public toStrDurable():string
  {
    return `[start_time ${this.start_time}   duration ${this.duration}   finish_time ${this.finish_clip_time}]`;
  }
}
